<div class="container">
  <!-- Map -->
  <div #mapContainer class="map"></div>

  <!-- Media Player Controls -->
  <div class="media-player" style="bottom: 15px; place-self: center; z-index: 9999;">
    <div class="controls">

      <!-- Rewind -->
      <div class="cursor" (click)="rewind()">
        <img src="../../../../assets/images/fast_rewind.svg" alt="rewind" />
      </div>

      <!-- Stop -->
      <div class="cursor" (click)="stop()">
        <div class="stop-button">⏹</div>
      </div>

      <!-- Play / Pause -->
      <div class="cursor" (click)="!playing ? togglePlay() : togglePlay()">
        <img *ngIf="!playing" src="../../../../assets/images/Play-data.svg" alt="play" />
        <img *ngIf="playing" src="../../../../assets/images/Pause-Icon.svg" alt="pause" />
      </div>

      <!-- Fast Forward -->
      <div class="cursor" (click)="fastForward()">
        <img src="../../../../assets/images/fast_forward.svg" alt="forward" />
      </div>

      <!-- Slider -->
      <div class="slider-container">
        <!-- Elapsed time (left) -->
        <span class="time-duration">
          {{ formatDuration(elapsedSec) }}
        </span>

        <input type="range" class="slider w-240" [min]="firstTs" [max]="lastTs" [value]="playhead"
          (input)="seek($any($event.target).value)" />

        <!-- Total duration (right) -->
        <span class="time-duration">
          {{ formatDuration(totalDurationSec) }}
        </span>
      </div>

      <!-- Settings Icon (optional) -->
      <div>
        <img src="../../../../assets/images/play-settings.svg" alt="settings" />
      </div>
    </div>
  </div>
</div>